import { React, useState, useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { apiCall, apiCallAsync } from '../apiclient';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TagList from './TagList';
import { UserTagStatus } from '../classes/UserTag';
import { Card } from 'react-bootstrap';

const tagStatus = new UserTagStatus;

export default function UserTags(props) {
    /* props.user is the current user */
    const [inactiveItems, setInactiveItems] =
            useState({});
    const [privateItems, setPrivateItems] = 
            useState({});
    const [publicItems, setPublicItems] =
            useState({});
    const [itemCount, setItemCount] =
            useState(null);

    function getItemsByStatus(status) {
        switch(status) {
            case tagStatus.PRIVATE:
                return [privateItems, setPrivateItems];
                break;
            case tagStatus.PUBLIC:
                return [publicItems, setPublicItems];
                break;
            case tagStatus.INACTIVE:
                return [inactiveItems, setInactiveItems];
        }
    }

    const moveTag = (async (tag, fromList, toList) => {
        // console.log(`UserTag.moveTag(${tag}, ${fromList}, ${toList})`);
        if (fromList !== toList) {
            let postBody = {tags:[{tag_value: tag, status: toList}]};
            let result = await apiCallAsync('POST', `/users/${props.user.uuid}/tags`,
                                postBody);
            let [destinationItemList, updateDestination] = getItemsByStatus(toList);
            let [sourceItemList, updateSource] = getItemsByStatus(fromList);
            destinationItemList[tag] = toList;
            delete sourceItemList[tag];
            let itmCount = JSON.parse(itemCount);
            itmCount[fromList]--;
            itmCount[toList]++;
            updateDestination(destinationItemList);
            updateSource(sourceItemList);
            setItemCount(JSON.stringify(itmCount));
        }
    });

    useEffect(() => {
        // console.log(`UserTag.useEffect() ${itemCount}`)
        if (itemCount === null) {
            apiCall('get', `/users/${props.user.uuid}/tags`).then((allTags) => {
                let inactiveTags={};
                let privateTags={};
                let publicTags={};
                let itmCount = {};
                itmCount[tagStatus.PRIVATE] = 0;
                itmCount[tagStatus.PUBLIC] = 0;
                itmCount[tagStatus.INACTIVE] = 0;
                for (const [key, value] of Object.entries(allTags.tags)) {
                    switch(value) {
                        case tagStatus.PRIVATE:
                            privateTags[key] = value;
                            break;
                        case tagStatus.PUBLIC:
                            publicTags[key] = value;
                            break;
                        case tagStatus.INACTIVE:
                            inactiveTags[key] = value;
                    }
                    itmCount[value]++;
                }
                setItemCount(JSON.stringify(itmCount));
                setInactiveItems(inactiveTags);
                setPrivateItems(privateTags);
                setPublicItems(publicTags);

            }).catch((ex) => {
                console.error("Error getting user tags: " + ex);
                setItemCount(0);
            })
        } 
    }, [itemCount]);

    return(
      <DndProvider backend={HTML5Backend}>
        <Container style={{ 'max-height': '90vh'}}>
            <p></p>
            <Row>
                <Col style={{ 'height': '85vh', 'max-height': '85vh'}}>
                    <Card style={{'height': '100%', 'max-height': '100%'}}>
                        <Card.Title className="mx-auto">Inactive Tags</Card.Title>
                        <TagList tagType={tagStatus.INACTIVE} items={inactiveItems} 
                                tagMover={moveTag} itemCount={itemCount} />
                        <Card.Footer className="text-muted">
                            These tags were found in the catalog data, but are not available to be used when building song lists.  Drag them to either the Public or Private list to make them available
                        </Card.Footer>
                    </Card>
                </Col>
                <Col style={{ 'height': '85vh', 'max-height': '85vh' }}>
                    <Card style={{'height': '49%', 'max-height': '49%'}}>
                        <Card.Title className="mx-auto">Public Tags</Card.Title>
                        <TagList tagType={tagStatus.PUBLIC} items={publicItems} 
                                tagMover={moveTag} itemCount={itemCount} />
                        <Card.Footer className="text-muted">
                            These tags are available to be used for song lists and shown to others
                        </Card.Footer>
                    </Card><div style={{'height':'2%', 'max-height':'2%'}}></div>
                    <Card style={{'height': '49%', 'max-height': '49%'}}>
                        <Card.Title className="mx-auto">Private Tags</Card.Title>
                        <TagList tagType={tagStatus.PRIVATE} items={privateItems} 
                                tagMover={moveTag} itemCount={itemCount} />
                        <Card.Footer className="text-muted">
                            These tags are available to be used for song lists and only available to you
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
      </DndProvider>
    )
}